import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { IOrderPrint } from "../../../models/OrderManagement";
import CurrencyFormat from "../../../components/currencyFormat/CurrencyFormat";
import { calculatePriceByType } from "../../../helpers/utils/utils";
import { Typography, Box } from "@mui/material";
const TableComponent = ({ data, type }: { data: any; type: string | null }) => {
  let items: any = [];
  let additionalItems: any = [];
  let totalItemsPrice = 0;
  let totalItemsMsrp = 0;
  let totalBentleyMsrp = 0;
  let totalDealerPrice = 0;
  let savings = 0;
  let { salePriceMarkupModel } = data?.dealerContact;
  let { salePriceMarkupMotor } = data?.dealerContact;
  let { salePriceMarkupOption } = data?.dealerContact;
  let msrp = data?.msrp;
  const [selectedCheckboxes, setSelectedCheckboxes] = React.useState<{
    [key: string]: boolean;
  }>({});

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontWeight: 700,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    "&:last-child td, &:last-child th": {
      fontWeight: 700,
      border: 0,
    },
  }));

  const StyledPriceRow = styled(TableRow)(({ theme }) => ({
    "td , th": {
      border: 0,
    },
  }));

  React.useEffect(() => {
    const storedCheckboxes = sessionStorage.getItem("selectedCheckboxes");
    if (storedCheckboxes) {
      setSelectedCheckboxes(JSON.parse(storedCheckboxes));
    }
  }, []);

  const calculateCost = (data: any) => {
    const itemsDealerCost = data.reduce(
      (previousValue: number, currentValue: { price: number }) =>
        previousValue + Number(currentValue.price),
      0
    );
    const itemsMsrpCost = data.reduce(
      (previousValue: number, currentValue: { msrpPrice: number }) =>
        previousValue + Number(currentValue.msrpPrice),
      0
    );
    return { itemsDealerCost, itemsMsrpCost };
  };

  const createTableAdditionalItems = (data: any) => {

    let stateAdditionalItems = data?.additionalItems.filter((item: any) => selectedCheckboxes.hasOwnProperty(item.name));
    additionalItems = [...stateAdditionalItems];

    let { itemsDealerCost } = calculateCost(stateAdditionalItems);

    totalBentleyMsrp = totalBentleyMsrp + itemsDealerCost;
    totalDealerPrice = totalDealerPrice + itemsDealerCost;
    savings = totalBentleyMsrp - totalDealerPrice;
  };

  const getSalePriceMarkup = (name: string) => {
    return name.includes("Model:")
      ? salePriceMarkupModel
      : name.includes("Motor:")
      ? salePriceMarkupMotor
      : salePriceMarkupOption;
  };

  const createTableData = (data: IOrderPrint) => {
    let stateItems = [...data.items];
    salePriceMarkupModel = salePriceMarkupModel ? salePriceMarkupModel : 0;
    salePriceMarkupMotor = salePriceMarkupMotor ? salePriceMarkupMotor : 0;
    salePriceMarkupOption = salePriceMarkupOption ? salePriceMarkupOption : 0;
    msrp = msrp ? msrp : 0;

    stateItems = stateItems.map((item) => {
      const spm = getSalePriceMarkup(item.name);
      return {
        ...item,
        msrpPrice: calculatePriceByType(item.price, "msrp", msrp),
        price: calculatePriceByType(item.price, type, spm),
      };
    });
    let { itemsDealerCost, itemsMsrpCost } = calculateCost(stateItems);
    totalItemsPrice = itemsDealerCost;
    totalItemsMsrp = itemsMsrpCost;
    items = [...stateItems];
    totalBentleyMsrp = totalBentleyMsrp + itemsMsrpCost;
    totalDealerPrice = totalDealerPrice + itemsDealerCost;
    savings = totalBentleyMsrp - totalDealerPrice;
    createTableAdditionalItems(data);
  };
  createTableData(data);

  return (
    <Box className="container" sx={{width: "100%"}}>
      <Typography className="table-heading" mt="8px">
        Pricing and Options
      </Typography>
      <TableContainer className="price-table">
        <Table
          sx={{ minWidth: "50%" }}
          aria-label="customized table"
          className="show-action-column"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Item Name</StyledTableCell>
              <StyledTableCell align="right">Bentley MSRP</StyledTableCell>
              <StyledTableCell
                align="right"
                sx={{ display: "table-cell !important" }}
              >
                Dealer Price
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items &&
              items.map((row: any) => {
                return (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell>
                      <span style={{ lineHeight: "12px" }}>{row.name}</span>
                    </StyledTableCell>
                    <StyledTableCell align="right" width="20%">
                      <CurrencyFormat value={row.msrpPrice}></CurrencyFormat>
                    </StyledTableCell>
                    <StyledTableCell align="right" width="20%">
                      <CurrencyFormat value={row.price}></CurrencyFormat>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            <StyledTableRow>
              <StyledTableCell>
                <span style={{ lineHeight: "12px", fontWeight: "bold" }}>
                  BOAT + OPTIONS TOTAL
                </span>
              </StyledTableCell>
              <StyledTableCell align="right" width="20%">
                <span style={{ fontWeight: "bold" }}>
                  <CurrencyFormat value={totalItemsMsrp}></CurrencyFormat>
                </span>
              </StyledTableCell>
              <StyledTableCell align="right" width="20%">
                <span style={{ fontWeight: "bold" }}>
                  <CurrencyFormat value={totalItemsPrice}></CurrencyFormat>
                </span>
              </StyledTableCell>
            </StyledTableRow>
            {additionalItems.length > 0 &&
              additionalItems
                .filter((item: { name: any }) =>
                  selectedCheckboxes.hasOwnProperty(item.name)
                )
                .map((row: any) => {
                  return (
                    <StyledTableRow key={row.name}>
                      <StyledTableCell>
                        <span style={{ lineHeight: "12px" }}>{row.name}</span>
                      </StyledTableCell>
                      <StyledTableCell align="right" width="20%">
                        <CurrencyFormat value={row.price}></CurrencyFormat>
                      </StyledTableCell>
                      <StyledTableCell align="right" width="20%">
                        <CurrencyFormat value={row.price}></CurrencyFormat>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            <StyledPriceRow>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell align="right" width="20%" className="price-row">
                Bentley MSRP
              </StyledTableCell>
              <StyledTableCell align="right" width="20%" className="price-row">
                <CurrencyFormat value={totalBentleyMsrp} />
              </StyledTableCell>
            </StyledPriceRow>
            <StyledPriceRow>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell align="right" width="20%" className="price-row">
                Dealer Sale Price
              </StyledTableCell>
              <StyledTableCell align="right" width="20%" className="price-row">
                <CurrencyFormat value={totalDealerPrice} />
              </StyledTableCell>
            </StyledPriceRow>
            <StyledPriceRow>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell align="right" width="20%" className="price-row">
                Dealer Savings
              </StyledTableCell>
              <StyledTableCell
                align="right"
                width="20%"
                className="price-row text-color-red"
              >
                <CurrencyFormat value={savings} />
              </StyledTableCell>
            </StyledPriceRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableComponent;
